import React from 'react'

import { Link, withRouter } from 'react-router-dom';

import { Section, Table, Index, InfosBar, Firmware, Text, SensorStatus } from 'components';
import { Container, Button, Icon } from 'semantic-ui-react'

import { ModalCreateSensor } from 'modals';

import { EnumSensorStatus } from 'enums';

import { BreadcrumbHelper, Typeof, Functions } from 'utils';

const SENSORS_PER_PAGE = 10;

class SensorListScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      sensors: props.sensors,
      sensorCriteria: '',
      showSensorCreateModal: false
    };

    this.handleSensorSearch = this.handleSensorSearch.bind(this);

    this.toggleSensorCreateModal = this.toggleSensorCreateModal.bind(this);
    this.handleSensorCreateModalClose = this.handleSensorCreateModalClose.bind(this);

    this.handleSensorSelect = this.handleSensorSelect.bind(this);
  }

  componentWillMount() {

    BreadcrumbHelper.reset();
    BreadcrumbHelper.push('Accueil', '/');
    BreadcrumbHelper.push('Capteurs');
    BreadcrumbHelper.flush();
  }

  handleSensorSearch(criteria) {

    this.setState({
      sensorCriteria: criteria.replace(/(-|:)/g, ""),
    });
  }

  toggleSensorCreateModal() {
    this.setState({
      showSensorCreateModal: !this.state.showSensorCreateModal
    });
  }

  handleSensorCreateModalClose(sensor) {

    if (Typeof.object(sensor)) {

      let sensors = [...this.state.sensors];
      sensors.push(sensor);

      this.setState({
        sensors: sensors
      });
    }

    this.toggleSensorCreateModal();
  }

  handleSensorSelect(sensor) {

    //Navigate to sensor page
    this.props.history.push(`/sensors/${sensor.mac_address}`);
  }

  render() {

    const { sensors } = this.state;

    let columns = [
      {
        id: 'mac_address',
        header: 'Adresse MAC',
        value: (sensor) => sensor.mac_address,
        render: (sensor, macAddress) => {
          return (
            <Text style={{"mono" : true}}>
              {Functions.formatMacAddress(macAddress)}
            </Text>
          )
        }
      },
      {
        id: 'device',
        header: 'Valise',
        value: (sensor) => Typeof.number(sensor.device) ? sensor.device : null,
        render: (sensor, device) => {
          return device != null ? <Link to={`/devices/${device}`}><Index value={device} /></Link> : <Icon name="warning sign" color="yellow" />;
        },
        fit: true
      },
      {
        id: 'status',
        header: 'Status',
        value: (sensor) => EnumSensorStatus.name(sensor.status),
        render: (sensor, status) => {
          return <SensorStatus status={sensor.status} />
        },
        sort: (a, b) => {
          return EnumSensorStatus.weight(a.status) - EnumSensorStatus.weight(b.status);
        },
        fit: true
      },
      {
        id: 'firmware',
        header: 'Micrologiciel',
        value: (sensor) => sensor.firmware,
        render: (sensor, firmware) => {
          return <Firmware firmware={firmware} />
        },
        fit: true
      }
    ];

    return (
      <React.Fragment>
        <Container>

          {/* Sensors */}
          <Section title="Capteurs" onSearch={this.handleSensorSearch} actions={[

            // Add sensor
            <Button icon="add" content="Nouveau" onClick={this.toggleSensorCreateModal} key={0} />
          ]}>

            {sensors.length > 0 ? (

              <React.Fragment>

                {/* Number of available sensors */}
                <InfosBar mode="column">
                  <span>{sensors.length > 1 ? `${sensors.length} capteurs disponibles` : '1 capteur disponible'}</span>
                </InfosBar>

                {/* sensors list */}
                <Table columns={columns}
                  criteria={this.state.sensorCriteria}
                  items={sensors}
                  itemsPerPage={SENSORS_PER_PAGE}
                  onSelect={this.handleSensorSelect}
                  messageEmpty="Aucun capteur ne correspond à votre recherche"
                  getRowClass={(sensor) => !Typeof.number(sensor.device) ? 'warning' : undefined}
                />

              </React.Fragment>

            ) : (

                // No sensor available
                <InfosBar mode="row">
                  <span>Aucun capteur disponible</span>
                </InfosBar>

              )}

          </Section>

        </Container>

        {/* Modal create sensor */}
        {this.state.showSensorCreateModal &&
          <ModalCreateSensor onClose={this.handleSensorCreateModalClose} />
        }

      </React.Fragment>
    );
  }
}

export default withRouter(SensorListScene);
